export const customCardColors = {
  cyan: {
    background: '#e6fffb',
    borderColor: '#87e8de',
    icon: '#08979c',
  },
  green: {
    background: '#f6ffed',
    borderColor: '#b7eb8f',
    icon: '#389e0d',
  },
  gold: {
    background: '#fffbe6',
    borderColor: '#ffe58f',
    icon: '#d48806',
  },
  volcano: {
    background: '#fff2e8',
    borderColor: '#ffbb96',
    icon: '#d4380d',
  },
  blue: {
    background: '#e6f4ff',
    borderColor: '#91caff',
    icon: '#0958d9',
  },
};
